/*
 * @Description: 
 * @Author: 姜暖阳
 * @Date: 2021-07-08 15:10:26
 * @LastEditTime: 2022-05-23 17:31:26
 * @LastEditors: 赵大壮
 * @Reference: 
 */
import config from './nyConfig'
import ApiLogin from "./ApiJson/ApiLogin"
import ApiCompany from "./ApiJson/ApiCompany"
import ApiStaff from "./ApiJson/ApiStaff"
import ApiPublic from "./ApiJson/ApiPublic"
import ApiAssess from "./ApiJson/ApiAssess"
import ApiQuestion from "./ApiJson/ApiQuestion"
import ApiRule from "./ApiJson/ApiRule"
import ApiReport from "./ApiJson/ApiReport"
import ApiArticle from "./ApiJson/ApiArticle"
import ApiVideo from './ApiJson/ApiVideo'
import ApiInvestigate from './ApiJson/ApiInvestigate'
import ApiBanner from './ApiJson/ApiBanner'
import ApiExport from './ApiJson/ApiExport'
import ApiGoods from './ApiJson/ApiGoods'
import ApiStore from './ApiJson/ApiStore'
import ApiOrder from './ApiJson/ApiOrder'
import ApiCoupon from './ApiJson/ApiCoupon'
import ApiAdmin from './ApiJson/ApiAdmin'
import ApiPrework from "./ApiJson/ApiPreWork";

const api: { [key: string]: config } = {
    ...ApiPublic,
    ...ApiLogin,
    ...ApiStaff,
    ...ApiAssess,
    ...ApiQuestion,
    ...ApiRule,
    ...ApiCompany,
    ...ApiReport,
    ...ApiArticle,
    ...ApiVideo,
    ...ApiInvestigate,
    ...ApiBanner,
    ...ApiExport,
    ...ApiGoods,
    ...ApiStore,
    ...ApiOrder,
    ...ApiCoupon,
    ...ApiAdmin,
    ...ApiPrework,
}

export default api